export const normalize = (arr, key) =>
    arr.reduce(
        (accum, el) => ({
            ...accum,
            [el[key]]: el,
        }),
        {},
    );
